import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap";
import { InventoryService } from "../inventory.service";
import { CommonService } from "src/app/services/common.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-inventory-note-modal",
  templateUrl: "./inventory-note-modal.component.html",
  styleUrls: ["./inventory-note-modal.component.sass"],
})
export class InventoryNoteModalComponent implements OnInit {
  noteId: string;
  referenceId: string;
  content: string;
  notesForm: FormGroup;
  noteType: string = "inventory_item";

  constructor(
    private _fb: FormBuilder,
    private commonService: CommonService,
    private bsModalRef: BsModalRef,
    private api: InventoryService
  ) {}

  ngOnInit() {
    this.notesForm = this._fb.group({
      content: [this.content, [Validators.required, Validators.minLength(2)]],
    });
  }

  cancelModal() {
    this.bsModalRef.hide();
  }

  saveClicked() {
    this.bsModalRef.hide();

    if (this.noteId) {
      const data = {
        notes: this.content,
      };

      this.api.updateInventoryNotes(this.noteId, data).subscribe(
        (result: any) => {
          this.commonService.toast(result.message, "Success");
        },
        (error: any) => {
          this.commonService.toast(error.error.message, "Error");
        }
      );
    } else {
      const data = {
        referenceId: this.referenceId,
        noteType: this.noteType,
        notes: this.content,
      };

      this.api.addInventoryNote(data).subscribe(
        (result: any) => {
          this.commonService.toast(result.message, "Success");
        },
        (error: any) => {
          this.commonService.toast(error.error.message, "Error");
        }
      );
    }
  }
}
